module.exports = __webpack_public_path__ + "static/media/create_sections_submit_confirm_department.476b5c18.mov";